export const LOAD_TUTOR_DETAILS = "LOAD_TUTOR_DETAILS";
export const REMOVE_TUTOR_DETAILS = "REMOVE_TUTOR_DETAILS";
